// extracted by mini-css-extract-plugin
export var locationCard = "_fs-0";